/**
 * Get the country code from browser locale
 */
export function getBrowserLocale() {
    let locale;
    if (typeof window !== 'undefined' && window.navigator) {
        locale =
            // eslint-disable-next-line zeffo/no-navigator-language
            window.navigator.language || window.navigator.languages?.[0];
    }
    return locale;
}
